/**
 * Portal hero banner height (used for portal pages)
 */
export const PORTAL_BANNER_HEIGHT = 120;
